const getEnvVar = (key: string) => {
  if (process.env[key] === undefined) {
    throw new Error(`Env variable ${key} is required`);
  }
  return process.env[key] || '';
};

export const AUTH_ROUTE = '/login';
export const SIGNUP_ROUTE = '/register';

export const DEFAULT_VOICE = 'ca-en-wiseman';
export const DEFAULT_MALE_VOICE = 'ca-en-wiseman';
export const DEFAULT_FEMALE_VOICE = 'ca-en-britishreadinglady';

export const SENTRY_AUTH_TOKEN = getEnvVar('REACT_APP_SENTRY_AUTH_TOKEN');
export const ENVIRONMENT = getEnvVar('REACT_APP_ENVIRONMENT');
export const BASE_URL = getEnvVar('REACT_APP_BASE_URL');
export const EMAIL_VALIDATION_URL = getEnvVar('REACT_APP_EMAIL_VALIDATION_URL');
export const CHAT_BACKEND_URL = getEnvVar('REACT_APP_CHAT_BACKEND_URL');
export const CHAT_BACKEND_URL_WS = getEnvVar('REACT_APP_CHAT_BACKEND_URL_WS');
export const AMPLITUDE_API_KEY = getEnvVar('REACT_APP_AMPLITUDE_API_KEY');

// * Feature flags
export const FEATURE_FLAG_SIGNUP = getEnvVar('REACT_APP_FEATURE_FLAG_SIGNUP');
export const FEATURE_FLAG_CANVAS = getEnvVar('REACT_APP_FEATURE_FLAG_CANVAS');
export const FEATURE_FLAG_FORMAT = getEnvVar('REACT_APP_FEATURE_FLAG_FORMAT');
export const FEATURE_FLAG_STYLE = getEnvVar('REACT_APP_FEATURE_FLAG_STYLE');
export const FEATURE_FLAG_CHATGPT = getEnvVar('REACT_APP_FEATURE_FLAG_CHATGPT');
export const FEATURE_FLAG_BACKGROUND_COLOR = getEnvVar(
  'REACT_APP_FEATURE_FLAG_BACKGROUND_COLOR'
);
export const FEATURE_FLAG_CROP_ACTOR = getEnvVar(
  'REACT_APP_FEATURE_FLAG_CROP_ACTOR'
);
export const FEATURE_FLAG_DYNAMIC_ACTOR = getEnvVar(
  'REACT_APP_FEATURE_FLAG_DYNAMIC_ACTOR'
);
export const FEATURE_FLAG_STARTERS_USE_PREMIUM_VOICES = getEnvVar(
  'REACT_APP_FEATURE_FLAG_STARTERS_USE_PREMIUM_VOICES'
);
export const REACT_APP_FEATURE_FLAG_HQ_AVATARS = getEnvVar(
  'REACT_APP_FEATURE_FLAG_HQ_AVATARS'
);

// Constants
export const NAVIGATE_TO_HOMEPAGE = 'navigate_to_homepage';
export const LOGOUT_RESET = 'logout_reset';
